import { useQuery } from '@apollo/client';
import { checkIfLoggedIn } from '@blaze-cms/core-auth-ui';
import { Link } from '@blaze-cms/nextjs-components';
import UpdateUserAccount from './UpdateUserAccount';
import { GET_ACCOUNT_USER } from '../../services/querys';

const UpdateUserAccountWrapper = props => {
  const { readOnly = true, children } = props;
  const { id: userId } = checkIfLoggedIn();

  const isReadOnly = readOnly || readOnly === null;

  const { data = {}, loading: loadingUser } = useQuery(GET_ACCOUNT_USER, {
    variables: { id: userId },
    skip: !userId || !isReadOnly,
    fetchPolicy: 'network-only',
    context: { credentials: 'include' }
  });

  if (!isReadOnly) return <UpdateUserAccount {...props} />;

  if (loadingUser) return null;

  const { user: { userDetails } = {} } = data;

  // only render on client to stop modal issues with server side rendering,
  if (!userDetails && typeof window !== 'undefined') return children || null;
  if (!userDetails) return null;

  return (
    <div className="account__row">
      <div className="account__column account__column--padded">
        <p>
          <div className="account__edit">
            <div>
              <strong>
                {userDetails.title} {userDetails.firstname} {userDetails.lastname}
              </strong>
              <br />
              {userDetails.company}
              <br /> {userDetails.jobTitle}
              <br />
              <small>
                If you would like to change these details please
                <Link href="/contact"> contact us </Link> .
              </small>
            </div>
          </div>
        </p>
        <div className="divider" />
        <p>
          <div>
            <div>
              <strong>Email address</strong>
              <br />
              {userDetails.email}
              <br />
              <small>
                If you would like to change your email address please
                <Link href="/contact"> contact us </Link> .
              </small>
            </div>
          </div>
        </p>
        <p>
          <div>
            <div>
              <strong>Telephone no.</strong>
              <br />
              {userDetails.tel}
              <br />
              <small>
                If you would like to change these details please
                <Link href="/contact"> contact us </Link> .
              </small>
            </div>
          </div>
        </p>
        <div className="divider" />
      </div>
      <div className="account__column account__column--padded" />
    </div>
  );
};

export default UpdateUserAccountWrapper;
